import { ASIN_FILTER_MAX } from "@adpilot/shared";
import { z } from "zod";

/**
 * Applied ASIN filter in a route's search params: child ASINs, uppercased and
 * de-duplicated, capped like the API so a hand-edited URL can't make every read fail.
 */
export const asinFilterSearchSchema = z
  .array(
    z
      .string()
      .trim()
      .regex(/^[A-Za-z0-9]{10}$/)
      .transform((asin) => asin.toUpperCase()),
  )
  .max(ASIN_FILTER_MAX)
  .transform((asins) => [...new Set(asins)]);
